// extracted by mini-css-extract-plugin
module.exports = {"loadingContainer":"company_config_loadingContainer__3gBpG"};